export default "__VITE_ASSET__efa1ff2a__"